import { render, staticRenderFns } from "./CreateLetterForCourse.vue?vue&type=template&id=8fa5af8a&scoped=true&"
import script from "./CreateLetterForCourse.vue?vue&type=script&lang=js&"
export * from "./CreateLetterForCourse.vue?vue&type=script&lang=js&"
import style0 from "./CreateLetterForCourse.vue?vue&type=style&index=0&id=8fa5af8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa5af8a",
  null
  
)

export default component.exports